
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [userInfo, setUserInfo] = useState(() => JSON.parse(localStorage.getItem('userInfo') || 'null'));
  useEffect(() => {
    const syncAuth = () => setUserInfo(JSON.parse(localStorage.getItem('userInfo') || 'null'));
    window.addEventListener('storage', syncAuth);
    window.addEventListener('focus', syncAuth);
    window.addEventListener('authchange', syncAuth);
    return () => {
      window.removeEventListener('storage', syncAuth);
      window.removeEventListener('focus', syncAuth);
      window.removeEventListener('authchange', syncAuth);
    };
  }, []);
  const roles = userInfo?.businessRoles?.map((membership) => membership.role) || [];
  const businessRole = roles.includes('owner') ? 'owner' : roles.includes('manager') ? 'manager' : roles.includes('staff') ? 'staff' : null;
  const quickAppointment = userInfo && ['owner', 'manager'].includes(businessRole);
  const customerBooking = !userInfo || userInfo.role === 'admin' || (!businessRole && userInfo.role !== 'staff');
  return <footer className="site-footer">
    <div className="site-footer-inner">
      <div className="site-footer-brand"><img src="/elegance-booking-logo-transparent.png" alt="Elegance Booking" /><p>Discover trusted beauty and wellness providers, then book with confidence.</p></div>
      <div className="site-footer-links"><div><strong>Explore</strong><Link to="/">Marketplace</Link>{quickAppointment ? <Link to="/owner#owner-appointments">Set up customer appointment</Link> : customerBooking && <Link to="/appointment">Book an appointment</Link>}<Link to="/contact">Contact us</Link></div><div><strong>For businesses</strong><Link to="/pricing">Pricing</Link><Link to="/business-signup">Apply your business</Link><Link to="/login">Owner login</Link></div><div><strong>Policies</strong><Link to="/business-agreement">Business Agreement</Link><Link to="/privacy">Privacy Policy</Link><Link to="/marketplace-policies">Marketplace Policies</Link></div></div>
    </div><div className="site-footer-bottom"><span>© {new Date().getFullYear()} Elegance Booking</span><span>Elegance Booking is a service operated by Cardicom.</span><span>Applications are reviewed before approval.</span><span className="app-version">v3</span></div>
  </footer>;
}
